import React from 'react';
import Hero from '../components/landing/Hero';
import Problem from '../components/landing/Problem';
import Solution from '../components/landing/Solution';
import HowItWorks from '../components/landing/HowItWorks';
import Trust from '../components/landing/Trust';
import Pricing from '../components/landing/Pricing';
import FAQ from '../components/landing/FAQ';
import EmailCapture from '../components/landing/EmailCapture';
import Footer from '../components/landing/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <Trust />
      <div id="pricing">
        <Pricing />
      </div>
      <div id="faq">
        <FAQ />
      </div>
      <EmailCapture />
      <Footer />
    </div>
  );
};

export default LandingPage;
